import TwoParagraphsParagraphComponent from "./two-paragraphs-paragraph-component";
import TwoParagraphsParagraphConfig from "./two-paragraphs-paragraph-config";
import TwoParagraphsParagraphAdvancedConfig from "./two-paragraphs-paragraph-advanced-config";

export default {
  TwoParagraphsParagraphComponent,
  TwoParagraphsParagraphConfig,
  TwoParagraphsParagraphAdvancedConfig
};
